import BrokenImageIcon from "@mui/icons-material/BrokenImage";
import HealingIcon from "@mui/icons-material/Healing";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import FeedbackDialog from "../../../../components/dialogs/FeedbackDialog.js";
import { HOST_STATUS } from "../../../../lib/constants.js";

const getIcon = {
  [HOST_STATUS.DEAD]: BrokenImageIcon,
  [HOST_STATUS.HURT]: HealingIcon,
  [HOST_STATUS.OK]: HealthAndSafetyIcon,
};

const getTitle = ({ locales }) => ({
  [HOST_STATUS.DEAD]: locales["maintenance.diagnostics.result.update"],
  [HOST_STATUS.HURT]: locales["maintenance.diagnostics.result.update"],
  [HOST_STATUS.OK]: locales["maintenance.diagnostics.result.update"],
});

const getMessage = ({ locales }) => ({
  [HOST_STATUS.DEAD]: locales["maintenance.diagnostics.result.dead"],
  [HOST_STATUS.HURT]: locales["maintenance.diagnostics.result.hurt"],
  [HOST_STATUS.OK]: locales["maintenance.diagnostics.result.repaired"],
});

export default function ResultDialog({ locales, newStatus, onClose, show }) {
  return (
    <FeedbackDialog
      bodyPrimary={getMessage({ locales })[newStatus]}
      icon={getIcon[newStatus]}
      locales={locales}
      onClose={onClose}
      show={show}
      title={getTitle({ locales })[newStatus]}
    />
  );
}
